import { useTranslate } from 'core/hooks/useTranslate';
import Button from 'core/modules/atoms/Button/Button';
import InputCheckbox from 'core/modules/atoms/InputCheckbox/InputCheckbox';
import MenuAside from 'core/modules/components/asides/components/MenuAside/MenuAside';
import Accordion from 'core/modules/components/general/accordion';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

function FiltersDynamicAside({ open, onClose, filters, onApplyFilters, initialSelected, title, onChangeFilters }) {
  const { t } = useTranslate();

  // Estado: { [filterId]: Set de valores seleccionados }
  const getInitialState = () => {
    if (initialSelected) return { ...initialSelected };
    const state = {};
    filters.forEach((f) => {
      state[f.id] = [];
    });
    return state;
  };

  const [selected, setSelected] = useState(getInitialState());

  useEffect(() => {
    if (onChangeFilters) {
      onChangeFilters(selected);
    }
  }, [selected, onChangeFilters]);

  function handleCheckbox(filterId, value, checked) {
    setSelected((prev) => {
      const prevArr = prev[filterId] || [];
      return {
        ...prev,
        [filterId]: checked ? [...prevArr, value] : prevArr.filter((v) => v !== value),
      };
    });
  }

  function handleClear() {
    const cleared = {};
    filters.forEach((f) => {
      cleared[f.id] = [];
    });
    setSelected(cleared);
  }

  function handleApply() {
    onApplyFilters(selected);
    onClose();
  }

  const accordionTabs = filters.map((filter) => ({
    title: t(filter.label),
    children: (
      <div className="filters-dynamic-aside__checkbox-list">
        {filter.options.map((opt) => (
          <InputCheckbox
            key={opt.value}
            label={t(opt.label)}
            value={opt.value}
            checked={selected[filter.id]?.includes(opt.value)}
            onChange={(e) => handleCheckbox(filter.id, opt.value, e.target.checked)}
          />
        ))}
      </div>
    ),
  }));

  function getFooter() {
    return (
      <div className="filters-dynamic-aside__footer">
        <Button
          text={t('actions:Clear all')}
          color={Object.values(selected).flat().length === 0 ? 'transparent' : 'transparent-primary'}
          onClick={handleClear}
          variant="inline"
          size="small"
        />
        <Button text={t('actions:Apply')} onClick={handleApply} variant="inline" size="small" />
      </div>
    );
  }

  return (
    <MenuAside
      open={open}
      onClose={onClose}
      title={title || t('common:Filters')}
      footer={getFooter()}
      position="right"
      width={400}
      onShowClose={true}
      className="filters-dynamic-aside"
    >
      <Accordion tabs={accordionTabs} multi position="right" onClickTab={() => {}} />
    </MenuAside>
  );
}

FiltersDynamicAside.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  filters: PropTypes.array.isRequired,
  onApplyFilters: PropTypes.func,
  initialSelected: PropTypes.object,
  title: PropTypes.string,
  onChangeFilters: PropTypes.func,
};

FiltersDynamicAside.defaultProps = {
  open: false,
  onClose: function () {},
  onApplyFilters: function () {},
  initialSelected: undefined,
  title: '',
  onChangeFilters: function () {},
};

export default FiltersDynamicAside;
